import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class InquiryHistoryModalFacadeService {
  private dialogRef: MatDialogRef<any, any> | null = null;
  private backdropEl: HTMLElement | null = null;

  setDialogRef(dialogRef: MatDialogRef<any, any> | null): void {
    this.dialogRef = dialogRef;
  }

  getDialogRef(): MatDialogRef<any, any> | null {
    return this.dialogRef;
  }

  isOpen(): boolean {
    return !!this.dialogRef;
  }

  setBackdropElement(backdropEl: HTMLElement | null): void {
    this.backdropEl = backdropEl;
  }

  getBackdropElement(): HTMLElement | null {
    return this.backdropEl;
  }

  clear(): void {
    this.dialogRef = null;
    this.backdropEl = null;
  }
}
